import React, { useState } from "react"

import { Button, Icon, Tile } from "@/components"

import { useStyles } from "@/components/TopNavigation/components/SearchPopdown/DatasetsTab/DatasetsTab.styles"

import { DatasetsTabProps } from "@/components/TopNavigation/types"

const DATASETS_LIMIT = 12

export const DatasetsTab = (props: DatasetsTabProps) => {
    const [isExpanded, setIsExpanded] = useState(false)
    const { classes } = useStyles({ isExpanded })

    const { datasetsOptions, gridItemOnClick } = props

    const renderedDatasets = isExpanded ? datasetsOptions : datasetsOptions.slice(0, DATASETS_LIMIT)
    const hasExpandButton = datasetsOptions.length > DATASETS_LIMIT

    const toggleIsExpanded = () => setIsExpanded((previousExpanded) => !previousExpanded)

    const renderDataset = (datasetOption) => (
        <Tile
            key={datasetOption.value}
            orientation="vertical"
            badge={Userdata.default_search_data_type === datasetOption.value && <Icon icon="star" iconFamily="fas" />}
            icon={<Icon icon={datasetOption.fa5_icon} iconFamily={datasetOption.fa5_icon_family} />}
            variant="secondary"
            onClick={(event) => {
                gridItemOnClick(event, datasetOption.value)
            }}
            size="md"
        >
            {datasetOption.qdtLabel || datasetOption.plural}
        </Tile>
    )

    return (
        <div className={classes.container}>
            <div className={classes.grid}>{renderedDatasets.map((dataset) => renderDataset(dataset))}</div>
            <div className={classes.footer}>
                {hasExpandButton && (
                    <Button variant="ghost" className={classes.more} onClick={toggleIsExpanded}>
                        {isExpanded ? (
                            <>
                                Less <Icon icon="angle-up" />
                            </>
                        ) : (
                            <>
                                More <Icon icon="angle-down" />
                            </>
                        )}
                    </Button>
                )}
            </div>
        </div>
    )
}
